import React from 'react';

/**
 * Debug component to help figure out which prop is causing a rerender
 * @param props the props your component gets called with
 *
 */

export const useImmutablePropsCheck = (props) => {
  const lastProps = React.useRef(props);

  React.useEffect(() => {
    Object.keys(props).forEach((k) => {
      if (props[k] !== lastProps.current[k]) {
        // eslint-disable-next-line
        console.info(`DEBUG prop ${k} changed`, props[k], lastProps.current[k]);
      }
    });
    lastProps.current = props;
  });
};
